import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuthContext } from './hooks/useAuth';
import { SignIn } from './pages/SignIn';
import { AuthCallback } from './pages/AuthCallback';
import { Campaigns } from './pages/Campaigns';
import { NewCampaign } from './pages/NewCampaign';
import { CampaignDetail } from './pages/CampaignDetail';
import { BriefTab } from './pages/campaign-tabs/BriefTab';
import { AssetsTab } from './pages/campaign-tabs/AssetsTab';
import { JobsListTab } from './pages/campaign-tabs/JobsListTab';
import { JobView } from './pages/campaign-tabs/JobView';
import { HiggsfieldTab } from './pages/campaign-tabs/HiggsfieldTab';
import { Characters } from './pages/Characters';
import { NewCharacter } from './pages/NewCharacter';
import { CharacterDetail } from './pages/CharacterDetail';
import { AdminGate } from './pages/AdminGate';
import { Shell } from './components/Shell';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          <Route element={<RequireAuth />}>
            <Route element={<RequireAdmin />}>
              <Route element={<Shell />}>
                <Route index element={<Navigate to="/campaigns" replace />} />
                <Route path="campaigns" element={<Campaigns />} />
                <Route path="campaigns/new" element={<NewCampaign />} />
                <Route path="campaigns/:id" element={<CampaignDetail />}>
                  <Route index element={<Navigate to="brief" replace />} />
                  <Route path="brief" element={<BriefTab />} />
                  <Route path="assets" element={<AssetsTab />} />
                  <Route path="higgsfield" element={<HiggsfieldTab />} />
                  <Route path="jobs" element={<JobsListTab />} />
                  <Route path="jobs/:jobId" element={<JobView />} />
                </Route>
                <Route path="characters" element={<Characters />} />
                <Route path="characters/new" element={<NewCharacter />} />
                <Route path="characters/:id" element={<CharacterDetail />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function RequireAuth() {
  const { session, loading } = useAuthContext();
  if (loading) return <CenteredSpinner />;
  if (!session) return <Navigate to="/sign-in" replace />;
  return <Outlet />;
}

function RequireAdmin() {
  const { profile, loading } = useAuthContext();
  if (loading) return <CenteredSpinner />;
  if (!profile?.is_admin) return <AdminGate />;
  return <Outlet />;
}

function CenteredSpinner() {
  return (
    <div className="center-page">
      <div className="spinner" />
    </div>
  );
}
